import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { MENU_ITEMS } from '../../pages/pages-menu';
import { Roles } from '../enums/app-roles.enum';
import { AppConsts } from '../services/app-const';

@Injectable()
export class RouteResolver implements Resolve<boolean> {
  constructor(private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let accessDenied: boolean = true;
    if (
      (state.url.includes('ledger') || state.url === '/') &&
      AppConsts.roles &&
      AppConsts.roles[0].name === Roles.MCDIENSTEN
    ) {
      accessDenied = false;
      this.setSelectedMenu(`/reports`);
      this.router.navigateByUrl(`/reports`);
    }

    if (
      (state.url.includes('ledger') || state.url === '/') &&
      AppConsts.roles &&
      (AppConsts.roles[0].name === Roles.HK_ADMIN ||
        AppConsts.roles[0].name === Roles.COST_APPROVER ||
        AppConsts.roles[0].name === Roles.MCDONALDS_CORPORATE ||
        AppConsts.roles[0].name === Roles.SERVICE_CONTROLLER ||
        AppConsts.roles[0].name === Roles.STORE_APPROVER ||
        AppConsts.roles[0].name === Roles.STORE_OWNER)
    ) {
      accessDenied = false;
      this.setSelectedMenu(`/ledger`);
      this.router.navigateByUrl(`/ledger`);
    }

    if (accessDenied) {
      this.router.navigate(['/access-denied'], { skipLocationChange: true });
    }

    return Promise.resolve(true);
  }

  private setSelectedMenu(url: string) {
    MENU_ITEMS.forEach(element => {
      if (element.link?.includes(url)) {
        element.selected = true;
      } else {
        element.selected = false;
      }
    });
  }
}
